

































































import Vue from 'vue';
import componentMixin from '@/utils/componentMixin';

export default Vue.extend({
	mixins: [componentMixin],
});
